var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-view"},[_c('div',{staticClass:"pdf-view_content",style:(_vm.customStyles)},[(!_vm.reload)?_c('iframe',{staticClass:"border-rounded",attrs:{"allow":"*","src":_vm.url}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }